import { render, staticRenderFns } from "./SliderCom.vue?vue&type=template&id=579b2ad9&"
import script from "./SliderCom.vue?vue&type=script&lang=ts&"
export * from "./SliderCom.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports